import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const IzinSayfasi = () => {
  const [personeller, setPersoneller] = useState([]);
  const [izinler, setIzinler] = useState([]);
  const [selectedPersonel, setSelectedPersonel] = useState('');
  const [izinTur, setIzinTur] = useState('Yıllık İzin');
  const [basTar, setBasTar] = useState('');
  const [bitTar, setBitTar] = useState('');
  const [basSaat, setBasSaat] = useState('');
  const [bitSaat, setBitSaat] = useState('');
  const [aciklama, setAciklama] = useState('');

  // Yeni: takvim ayarları ve tatiller
  const [holidays, setHolidays] = useState([]);              // "YYYY-MM-DD" dizi
  const [saturdayMode, setSaturdayMode] = useState('full');  // 'full' | 'half' | 'off'
  const [calcDays, setCalcDays] = useState(null);            // hesaplanan izin düşecek gün

  const role = localStorage.getItem('role');
  const username = localStorage.getItem('username');
  const navigate = useNavigate();

  useEffect(() => {
    // Personel ve izinleri çek
    fetch(`https://api.idekod.com.tr/api/personel?role=${role}&username=${username}`)
      .then(r => r.json())
      .then(data => {
        setPersoneller(data || []);
        if (role !== '1' && data?.length) {
          setSelectedPersonel(data[0]?.TELNO);
        }
      })
      .catch(err => console.error('Personel bilgileri alınırken hata:', err));

    fetchIzinler();

    // Takvim ayarları ve tatilleri çek
    fetch('https://api.idekod.com.tr/api/calendar/settings')
      .then(r => r.json())
      .then(d => setSaturdayMode(d?.saturday_mode || 'full'))
      .catch(() => setSaturdayMode('full'));

    fetch('https://api.idekod.com.tr/api/tatiller')
      .then(r => r.json())
      .then(list => {
        const onlyDates = Array.isArray(list) ? list.map(x => x.tarih || x.date || x).map(toISODate) : [];
        setHolidays(onlyDates);
      })
      .catch(() => setHolidays([]));
  }, [role, username]);

  const fetchIzinler = () => {
    fetch(`https://api.idekod.com.tr/api/izinler?role=${role}&username=${username}`)
      .then(r => r.json())
      .then(d => setIzinler(Array.isArray(d) ? d : []))
      .catch(err => console.error('İzinler alınırken hata oluştu:', err));
  };

  // Yardımcı: Date -> 'YYYY-MM-DD'
  function toISODate(input) {
    const d = new Date(input);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  // Günlük izin hesaplama (resmi tatil/pazar hariç; cumartesi half/full/off)
  const calculateLeaveDays = (startStr, endStr) => {
    if (!startStr || !endStr) return null;
    const start = new Date(startStr);
    const end = new Date(endStr);
    if (isNaN(start) || isNaN(end) || start > end) return null;

    let total = 0;
    const holidaySet = new Set(holidays);

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const iso = toISODate(d);
      const dow = d.getDay(); // 0: Pazar, 6: Cumartesi

      // Resmi tatil
      if (holidaySet.has(iso)) continue;

      // Pazar
      if (dow === 0) continue;

      // Cumartesi
      if (dow === 6) {
        if (saturdayMode === 'off') continue;
        if (saturdayMode === 'half') { total += 0.5; continue; }
        // 'full'
        total += 1;
        continue;
      }

      // Hafta içi
      total += 1;
    }
    return total;
  };

  // Ekranda anlık gösterim için hesapla (Yıllık/Günlük izinlerde)
  useEffect(() => {
    if (izinTur === 'Saatlik İzin') {
      setCalcDays(null);
      return;
    }
    setCalcDays(calculateLeaveDays(basTar, bitTar));
  }, [basTar, bitTar, izinTur, holidays, saturdayMode]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedPersonel) {
      alert('Lütfen kullanıcı seçin.');
      return;
    }

    // Önce backend kontrol (tatil/hafta sonu ve hakediş)
    try {
      const kontrolRes = await fetch('https://api.idekod.com.tr/api/izin/kontrol', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          telno: selectedPersonel,
          izintur: izinTur,
          bastar: basTar,
          bittar: bitTar,
          bassaat: izinTur === 'Saatlik İzin' ? basSaat : null,
          bitsaat: izinTur === 'Saatlik İzin' ? bitSaat : null,
        })
      });

      const kontrolData = await kontrolRes.json();

      if (!kontrolData?.success) {
        alert(kontrolData?.message || 'İzin kontrolü başarısız.');
        return;
      }

      // Onaylandıysa izin kaydı
      const payload = {
        TELNO: selectedPersonel,
        IZINTUR: izinTur,
        BASTAR: basTar,
        BITTAR: bitTar,
        BASSAAT: izinTur === 'Saatlik İzin' ? basSaat : null,
        BITSAAT: izinTur === 'Saatlik İzin' ? bitSaat : null,
        ACIKLAMA: aciklama
      };

      const res = await fetch('https://api.idekod.com.tr/api/izin2', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      alert(data?.message || 'İzin kaydedildi.');
      fetchIzinler();
    } catch (err) {
      console.error(err);
      alert('Sunucuya erişilirken hata oluştu.');
    }
  };

  const secilenKisi = useMemo(
    () => personeller.find(p => String(p.TELNO) === String(selectedPersonel)),
    [personeller, selectedPersonel]
  );

  return (
    <div className="p-6 space-y-8">
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="bg-gray-600 p-4 text-white">
          <h1 className="text-xl font-semibold text-center">İzin Talep Formu</h1>
        </div>

        <form onSubmit={handleSubmit} className="min-w-full table-auto mb-2 py-4 px-4">
          {role === '1' && (
            <>
              <select
                value={selectedPersonel}
                onChange={(e) => setSelectedPersonel(e.target.value)}
                className="mb-4 border rounded p-2 w-full"
              >
                <option value="">Kullanıcı Seç</option>
                {personeller.map(p => (
                  <option key={p.TELNO} value={p.TELNO}>{p.RNAME}</option>
                ))}
              </select>

              {selectedPersonel && (
                <div className="mb-4 p-2 border bg-gray-100 text-gray-700 font-medium rounded">
                  Hakedişiniz: <span className="text-black">{secilenKisi?.HAKEDISI ?? '-'}</span>
                </div>
              )}
            </>
          )}

          <select
            value={izinTur}
            onChange={(e) => setIzinTur(e.target.value)}
            className="mb-4 border rounded p-2 w-full"
          >
            <option value="Yıllık İzin">Yıllık İzin</option>
            <option value="Günlük İzin">Günlük İzin</option>
            <option value="Saatlik İzin">Saatlik İzin</option>
          </select>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <input
              type="date"
              value={basTar}
              onChange={(e) => setBasTar(e.target.value)}
              required
              className="mb-2 border rounded p-2 w-full"
            />
            <input
              type="date"
              value={bitTar}
              onChange={(e) => setBitTar(e.target.value)}
              required
              className="mb-2 border rounded p-2 w-full"
            />
          </div>

          {izinTur === 'Saatlik İzin' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <input
                type="time"
                value={basSaat}
                onChange={(e) => setBasSaat(e.target.value)}
                required
                className="mb-2 border rounded p-2 w-full"
              />
              <input
                type="time"
                value={bitSaat}
                onChange={(e) => setBitSaat(e.target.value)}
                required
                className="mb-2 border rounded p-2 w-full"
              />
            </div>
          )}

          <textarea
            value={aciklama}
            onChange={(e) => setAciklama(e.target.value)}
            placeholder="Açıklama Giriniz"
            className="mb-4 border rounded p-2 w-full"
          />

          {/* Bilgilendirme kartları */}
          {izinTur !== 'Saatlik İzin' && (
            <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="p-3 rounded border">
                <div className="text-sm text-gray-500">Cumartesi Kuralı</div>
                <div className="font-semibold">
                  {saturdayMode === 'half' ? 'Yarım gün say' :
                   saturdayMode === 'off'  ? 'Cumartesi sayma' : 'Tam gün say'}
                </div>
              </div>
              <div className="p-3 rounded border">
                <div className="text-sm text-gray-500">Tatiller</div>
                <div className="font-semibold">{holidays.length} gün</div>
              </div>
              <div className="p-3 rounded border">
                <div className="text-sm text-gray-500">Bu izin için düşecek</div>
                <div className="font-semibold">
                  {calcDays == null ? '-' : calcDays}
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-center mt-2">
            <button
              type="submit"
              className="w-full bg-customControl text-white font-semibold py-2 rounded-lg hover:bg-customColor2 transition duration-200"
            >
              Kaydet ve Onaya Gönder
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IzinSayfasi;
